import type { ThemeOptions } from '@mui/material';

import Typography from '../typography';

const DialogTitleTheme: ThemeOptions['components'] = {
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...Typography?.typography?.h2,
        zIndex: 0,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
          paddingLeft: theme.spacing(7),
          paddingRight: theme.spacing(7),
          paddingTop: theme.spacing(6),
        },
      }),
    },
  },
};

export default DialogTitleTheme;
